module.exports = __webpack_public_path__ + "img/thumb-invision-logo@2x.e9d9cd60.png";